import React from "react";
import ProfileContainer from "../containers/Profile";

const Profile = () => {
  return <ProfileContainer />;
};

export default Profile;
